import { useEffect, useState } from "react"
import { FrameWrapper, Frame, FrameHeading, StoryWrapper, Text, Correct, TranslateLink } from "./StoriesStyle"
import { StoriesData } from "../../../../07_speaking/03_stories/StoriesData"
import { useSelector } from "react-redux"

const Stories = () => {

  const currentLesson = useSelector(state => state.lesson.currentLesson)

  const [storiesData, setStoriesData] = useState(
    StoriesData.filter(val => val.lesson === currentLesson)
  )

  const clickTranslate = (e) => {
    e.preventDefault();
    let prevStoriesData = [...storiesData]
    prevStoriesData[0].display = prevStoriesData[0].display === "none" ? "block" : "none"
    setStoriesData(prevStoriesData)
  }

  useEffect(() => {
    setStoriesData(StoriesData.filter(val => val.lesson === currentLesson))
  }, [currentLesson])

  return (

      <Frame>
        <FrameHeading>Story</FrameHeading>
          <Text>{storiesData[0].story}</Text>
          <TranslateLink onClick={clickTranslate}>Переклад</TranslateLink>
          <Correct style={{ display: storiesData[0].display }}>
            {storiesData[0].translation}
          </Correct>
      </Frame>

  )
}

export default Stories